// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&family=Raleway:ital,wght@0,400;0,600;1,400;1,500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
/* 
font-family: 'Poppins', sans-serif;
font-family: 'Raleway', sans-serif; */

body {
  font-family: "Raleway", sans-serif;
  overflow-x: hidden;
}

:root {
  --main-gradient: -webkit-linear-gradient(105deg, #4158d0 41%, #c850c0 46%);
  --light-black: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.15) 0%,
      rgba(0, 0, 0, 1) 100%
    ),
    radial-gradient(
        at top center,
        rgba(255, 255, 255, 0.9) 0%,
        rgba(0, 0, 0, 0.4) 120%
      )
      #989898;
  background-blend-mode: multiply, multiply;
  --main-hover-gradient: -webkit-linear-gradient(
    105deg,
    #c850c0 41%,
    #4158d0 46%
  );
  --white: #ffffff;
  --black: #000000;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 18px !important;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.main-heading {
  text-align: center;
  font-size: 36px;
  font-weight: 600;
}

.align-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cm-btn-one {
  color: #000;
  font-size: 14px;
  padding: 9px 12px;
  border-radius: 6px;
  border: 1px solid #cdc4c4;  
  outline: none;             
  box-shadow: none; 
  cursor: pointer;
  margin: 0px 2px;
}
.cm-btn-one:hover {
  background-color: #4158d0;
  color: #fff;
}

.cm-btn-one:focus {
  outline: none;
}

.red-cl {
  color: #ff6060;
}

.green-cl {
  color: #49cc90;
}
.w-one-fifty {
  width: 150px !important;
}

.three-item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  padding: 30px 0px;
}

.small-heading {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 6px;
}

.scalaton-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;
}

.login-btn {
  padding: 12px 24px;
  background: var(--main-gradient);
  border-radius: 10px;
  color: var(--white);
  width: 100%;
  outline: none;
  border: none;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 800;
  cursor: pointer;
  margin: 0px 2px;
}

.login-btn:hover {
  background: var(--main-hover-gradient);
}

.login-btn:focus {
  outline: none;
}

.common-gap {
  padding: 20px;
}

.error-display {
  color: #dc3545;
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 13px;
}

.user-info {
  border: 1px solid #6b6969;
  padding: 20px 10px;
  margin: 10px 0px;
  font-size: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.user-info p {
  margin-bottom: 5px;
}

.hover-w:hover {
  background-color: #fff;
  color: #000;
}

.linkactive {
  background-color: #000;
  color: #fff;
}

.cross-click {
  position: absolute;
  top: 0;
  font-size: 20px;
  transition: opacity 0.3s ease-in-out;
  color: #938c8c;
}

.start-btn {
  background-color: #c850c0;
  color: #fff;
  border-radius: 6px;
  padding: 8px 12px;
}

.css-levciy-MuiTablePagination-displayedRows {
  margin-bottom: 0px !important;
}
.css-rtrcn9-MuiTablePagination-root .MuiTablePagination-selectLabel {
  margin-bottom: 0px !important;
}

.gap-time {
  padding: 10px;
  margin: 10px 0px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gapuser-details {
  display: flex;
  gap: 12px;
}
.gapuser-details h6 {
  font-weight: bold;
}

.gap-time p {
  padding: 10px;
  margin: 10px 0px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background-color: #4158d0;
  color: #fff;
}

@media only screen and (max-width: 768px) {
  .user-info {
    grid-template-columns: 1fr;
  }
}

@media only screen and (max-width: 576px) {
  .small-heading {
    font-size: 18px;
  }
}

.reason-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flex-justify-center {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.ant-btn {
  line-height: normal;
}

.ant-btn {
  display: inline-flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AAGA;;qCAEqC;;AAIrC;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,0EAA0E;EAC1E;;;;;;;;;;aAUW;EACX,yCAAyC;EACzC;;;;GAIC;EACD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,eAAe;EACf,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&family=Raleway:ital,wght@0,400;0,600;1,400;1,500&display=swap\");\n/* \nfont-family: 'Poppins', sans-serif;\nfont-family: 'Raleway', sans-serif; */\n\n@import url(\"https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;700&display=swap\");\n\nbody {\n  font-family: \"Raleway\", sans-serif;\n  overflow-x: hidden;\n}\n\n:root {\n  --main-gradient: -webkit-linear-gradient(105deg, #4158d0 41%, #c850c0 46%);\n  --light-black: linear-gradient(\n      to bottom,\n      rgba(255, 255, 255, 0.15) 0%,\n      rgba(0, 0, 0, 1) 100%\n    ),\n    radial-gradient(\n        at top center,\n        rgba(255, 255, 255, 0.9) 0%,\n        rgba(0, 0, 0, 0.4) 120%\n      )\n      #989898;\n  background-blend-mode: multiply, multiply;\n  --main-hover-gradient: -webkit-linear-gradient(\n    105deg,\n    #c850c0 41%,\n    #4158d0 46%\n  );\n  --white: #ffffff;\n  --black: #000000;\n}\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #888 #f1f1f1;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 18px !important;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.main-heading {\n  text-align: center;\n  font-size: 36px;\n  font-weight: 600;\n}\n\n.align-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cm-btn-one {\n  color: #000;\n  font-size: 14px;\n  padding: 9px 12px;\n  border-radius: 6px;\n  border: 1px solid #cdc4c4;  \n  outline: none;             \n  box-shadow: none; \n  cursor: pointer;\n  margin: 0px 2px;\n}\n.cm-btn-one:hover {\n  background-color: #4158d0;\n  color: #fff;\n}\n\n.cm-btn-one:focus {\n  outline: none;\n}\n\n.red-cl {\n  color: #ff6060;\n}\n\n.green-cl {\n  color: #49cc90;\n}\n.w-one-fifty {\n  width: 150px !important;\n}\n\n.three-item {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 20px;\n  padding: 30px 0px;\n}\n\n.small-heading {\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.scalaton-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 10px;\n}\n\n.login-btn {\n  padding: 12px 24px;\n  background: var(--main-gradient);\n  border-radius: 10px;\n  color: var(--white);\n  width: 100%;\n  outline: none;\n  border: none;\n  font-size: 18px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  font-weight: 800;\n  cursor: pointer;\n  margin: 0px 2px;\n}\n\n.login-btn:hover {\n  background: var(--main-hover-gradient);\n}\n\n.login-btn:focus {\n  outline: none;\n}\n\n.common-gap {\n  padding: 20px;\n}\n\n.error-display {\n  color: #dc3545;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  font-size: 13px;\n}\n\n.user-info {\n  border: 1px solid #6b6969;\n  padding: 20px 10px;\n  margin: 10px 0px;\n  font-size: 14px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n\n.user-info p {\n  margin-bottom: 5px;\n}\n\n.hover-w:hover {\n  background-color: #fff;\n  color: #000;\n}\n\n.linkactive {\n  background-color: #000;\n  color: #fff;\n}\n\n.cross-click {\n  position: absolute;\n  top: 0;\n  font-size: 20px;\n  transition: opacity 0.3s ease-in-out;\n  color: #938c8c;\n}\n\n.start-btn {\n  background-color: #c850c0;\n  color: #fff;\n  border-radius: 6px;\n  padding: 8px 12px;\n}\n\n.css-levciy-MuiTablePagination-displayedRows {\n  margin-bottom: 0px !important;\n}\n.css-rtrcn9-MuiTablePagination-root .MuiTablePagination-selectLabel {\n  margin-bottom: 0px !important;\n}\n\n.gap-time {\n  padding: 10px;\n  margin: 10px 0px;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.gapuser-details {\n  display: flex;\n  gap: 12px;\n}\n.gapuser-details h6 {\n  font-weight: bold;\n}\n\n.gap-time p {\n  padding: 10px;\n  margin: 10px 0px;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  background-color: #4158d0;\n  color: #fff;\n}\n\n@media only screen and (max-width: 768px) {\n  .user-info {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .small-heading {\n    font-size: 18px;\n  }\n}\n\n.reason-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.flex-justify-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.ant-btn {\n  line-height: normal;\n}\n\n.ant-btn {\n  display: inline-flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
